import { Text, View } from "react-native";

import { Modal } from "~/components/AccountActions/modal.web";
import { Button } from "~/ui/Button";

export const ConfirmationDialog = ({
  onConfirm,
  onCancel,
}: {
  onConfirm: () => void;
  onCancel?: () => void;
}) => {
  return (
    <Modal onDismiss={onCancel ?? (() => {})}>
      <View className="gap-2">
        <Text className="text-text-primary text-lg">Are you sure?</Text>
        <Text className="text-text-primary">This action can not be undone</Text>
      </View>
      <View className="flex-row gap-4">
        <Button size="small" variant="danger" onPress={onConfirm}>
          Yes
        </Button>
        <Button size="small" variant="secondary" onPress={onCancel}>
          Cancel
        </Button>
      </View>
    </Modal>
  );
};
